/**
 * Shared locale constants to prevent duplication
 * Used by both app.js bootstrap and translation loaders
 */

export const EN_LOCALE_DATA = {
    AMPMS: ['AM', 'PM'],
    DAY: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    ERANAMES: ['Before Christ', 'Anno Domini'],
    ERAS: ['BC', 'AD'],
    FIRSTDAYOFWEEK: 6,
    MONTH: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    SHORTDAY: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    SHORTMONTH: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    STANDALONEMONTH: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    WEEKENDRANGE: [5, 6],
    fullDate: 'EEEE, d MMMM y',
    longDate: 'd MMMM y',
    medium: 'd MMM y H:mm:ss',
    mediumDate: 'd MMM y',
    mediumTime: 'H:mm:ss',
    short: 'd/M/yy H:mm',
    shortDate: 'd/M/yy',
    shortTime: 'H:mm',
};
